import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Eyebrow } from "@/components/Reveal";

export default function PrivacyPage() {
  return (
    <main data-testid="privacy-page" className="mx-auto max-w-2xl px-5 py-16 sm:py-24">
      <Link to="/" data-testid="back-home-link" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.3em] text-cream/60 transition-colors hover:text-lime">
        <ArrowLeft className="h-4 w-4" /> BACK
      </Link>
      <Eyebrow>WILD WOMAN MILLIONS™</Eyebrow>
      <h1 className="mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl">Privacy Policy</h1>
      <p className="mt-2 font-mono text-[10px] tracking-[0.3em] text-cream/40">LAST UPDATED: 2026</p>

      <div className="mt-10 space-y-8 text-sm leading-relaxed text-cream/70">
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Overview</h2>
          <p>Wild Woman Millions™ (“we”, “our”) is a digital educational experience by Dasha Love. This policy explains what information is collected when you visit this page or purchase, and how it is used.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Information We Collect</h2>
          <p>This page itself does not collect personal information. When you choose to purchase, your order is processed by our payment provider (Stripe). Stripe collects the information needed to complete your payment — such as your name, email address, and payment details — under its own privacy policy. We receive only the information required to deliver your digital access (typically your name and email address).</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">How We Use It</h2>
          <p>Your information is used to deliver the course and digital books, provide customer support, and — if you opt in — send occasional emails about the course and related work. We do not sell your personal information.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Cookies + Analytics</h2>
          <p>This page may use privacy-respecting analytics in the future to understand aggregate traffic. No advertising trackers are installed on this page at this time.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Your Choices</h2>
          <p>You may request access to, correction of, or deletion of your personal information at any time by contacting us. You can unsubscribe from emails using the link in any message.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Contact</h2>
          <p>Questions about this policy can be sent via the contact link in the footer of this page.</p>
        </section>
      </div>
    </main>
  );
}
